<template>
  <span aria-hidden="true"></span>
</template>

<script>
const { siteLanguageMixin } = require('@/utils/site-language.js')

export default {
  name: 'ConsentManager',
  mixins: [siteLanguageMixin],
  mounted() {
    if (!document.getElementById('anovator-consent-styles')) {
      const stylesheet = document.createElement('link')
      stylesheet.id = 'anovator-consent-styles'
      stylesheet.rel = 'stylesheet'
      stylesheet.href = '/static/css/consent.css'
      document.head.appendChild(stylesheet)
    }

    if (window.AnovatorConsent) {
      window.AnovatorConsent.setLanguage(this.currentLanguage)
      return
    }
    if (document.getElementById('anovator-consent-bootstrap')) return

    const script = document.createElement('script')
    script.id = 'anovator-consent-bootstrap'
    script.src = '/static/js/consent-bootstrap.js'
    script.dataset.siteLanguage = this.currentLanguage
    script.onload = () => window.AnovatorConsent?.setLanguage(this.currentLanguage)
    document.head.appendChild(script)
  },
  watch: {
    currentLanguage(language) {
      window.AnovatorConsent?.setLanguage(language)
    }
  }
}
</script>
